module.exports = __webpack_public_path__ + "static/media/google-icon.f448f860.svg";